import { ADMIN_CENTER_DATA } from '@routes/sidebar/___shared___/api/constants.ts';

export const VESSELS_STEP_TITLE = 'vessels';

export const VESSELS_DATA_PAYLOAD = {
    dataToReturn: [
        ADMIN_CENTER_DATA.FLAGS,
        ADMIN_CENTER_DATA.VESSEL_SUB_TYPES,
        ADMIN_CENTER_DATA.VESSEL_EQUIPMENT_TYPES,
        ADMIN_CENTER_DATA.FUEL_TYPES,
        ADMIN_CENTER_DATA.TRADING_AREAS,
        ADMIN_CENTER_DATA.VESSEL_GROUPS,
        ADMIN_CENTER_DATA.SHORE_TEAMS,
        ADMIN_CENTER_DATA.SHORE_USERS,
        ADMIN_CENTER_DATA.SHORE_DEPARTMENT_TYPES,
        ADMIN_CENTER_DATA.SHORE_DEPARTMENTS,
        ADMIN_CENTER_DATA.VESSEL_EQUIPMENT_DETAILS,
    ],
};
